import mediumEmphasis from '../../text/medium-emphasis';

const light = (params) => mediumEmphasis(params);

export default light;
